// extracted by mini-css-extract-plugin
module.exports = {"main":"Dimensions_main___z1VY","top":"Dimensions_top__pcfjw","subHeading":"Dimensions_subHeading__eqfBe","parent":"Dimensions_parent__wAecT"};